var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading_1_",
    "data-name": "loading (1)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1642",
    "data-name": "Ellipse 1642",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(15.8 4.2)",
    fill: "rgba(160,125,31,0.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1643",
    "data-name": "Ellipse 1643",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(10 2)",
    fill: "rgba(137,107,26,0.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1644",
    "data-name": "Ellipse 1644",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(4.2 4.2)",
    fill: "rgba(229,194,98,0.9)",
    opacity: 0.657
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1645",
    "data-name": "Ellipse 1645",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(2 10)",
    fill: "rgba(201,162,58,0.9)",
    opacity: 0.751
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1646",
    "data-name": "Ellipse 1646",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(4.2 15.6)",
    fill: "rgba(193,155,53,0.9)",
    opacity: 0.787
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(10 18)",
    fill: "rgba(180,141,37,0.9)",
    opacity: 0.698
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1648",
    "data-name": "Ellipse 1648",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(15.8 15.6)",
    fill: "rgba(191,150,40,0.9)",
    opacity: 0.846
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1649",
    "data-name": "Ellipse 1649",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(18 10)",
    fill: "rgba(172,135,37,0.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/In progress.207b1676b86adeaf5dc6dffaeea91f79.svg";
export { ForwardRef as ReactComponent };